import { type PointerEvent, useMemo } from 'react';
import { Header } from '@tanstack/react-table';
import { useSortable } from '@dnd-kit/sortable';

export const useDraggableColumnOrder = (header: Header<any, unknown>) => {
  const { listeners, setNodeRef, isDragging } = useSortable({ id: header.id });

  return useMemo(
    () => ({
      ref: setNodeRef,
      isDragging,
      ...listeners,
      // Enable drag-sortable column ordering by the element that has
      // the "drag-sortable" class name, excluding any child elements with'
      // "exclude-drag-sortable" class name.
      onPointerDown: (event: PointerEvent) => {
        let element: HTMLElement | null = event.target as HTMLElement;

        while (element) {
          if (element.classList.contains('exclude-drag-sortable')) {
            return;
          }
          if (element.classList.contains('drag-sortable')) {
            listeners?.onPointerDown?.(event);
            return;
          }
          element = element.parentElement;
        }
      },
    }),
    [setNodeRef, listeners],
  );
};
